<template>
  <div>
    <el-dialog :title="title" width="500px" :z-index="6000" :append-to-body="true" :visible.sync="isVisible" @close="closeModal">
      <div class="verification" ref="verification">
      <!-- 画布部分 -->
      <canvas ref="slideVerify" class="slide-img"></canvas>
      <div style="display:none">
        <img ref="imgs" :src="imgList[imgIndex]"/>
      </div>
      <!-- 下面滑块部分 -->
      <div class="slide-wrapper bg-start">
        <!-- 滑块 -->
        <div class="btn" ref="btn" @mousedown="mouseDown" @mouseup="mouseUp" :disabled="!isEnabled">
          <span class="iconfont"></span>
          <!-- 添加disabled属性，根据开关状态禁用滑块 -->
        </div>
        <p class="text" ref="text">{{content}}</p>
        <div class="bg" ref="bg"></div>
      </div>
      <!-- 刷新按钮 -->
      <button class="refresh" @click="refresh">
        <span class="iconfont icon-shuaxin"></span>
      </button>
    </div>

    </el-dialog>
    
  </div>
</template>

<script>
//   获取图像验证码X
import {getactivitySignUpRegister,setverifyCaptcha} from "@api/user";
// 
export default {
  data() {
    return {

      aes_key: 'ed8222',
      aes_script: '8NONwyJt',

      title: "",
      isVisible: false,

      imgIndex: 0,   //图片初始值
      maxImage: 9,  //图片个数+1
      isFlog: false,
      blockCanvas: null,
      imgList: [
      require('../../../assets/images/verify/verify1.jpg'),
      require('../../../assets/images/verify/verify2.jpg'),
      require('../../../assets/images/verify/verify3.jpg'),
      require('../../../assets/images/verify/verify4.jpg'), 
      require('../../../assets/images/verify/verify5.jpg'),
      require('../../../assets/images/verify/verify6.jpg'),
      require('../../../assets/images/verify/verify7.jpg'),
      require('../../../assets/images/verify/verify8.jpg'),
      require('../../../assets/images/verify/verify9.jpg'),
      require('../../../assets/images/verify/verify10.jpg')
       ],
      content: '滑动滑块',
      isDown: false, // 鼠标是否按下
      btnX: 0,
      imgX: 0,
      isEnabled: true, // 添加开关状态变量，初始值为开启

      // x轴
      xaxle: 0,
      yaxle: 0,
      token:"",

      phone:"",

    }
  },
  mounted() {
    
  //   
  },
  methods: {

     async openModal(phone){
      this.phone=phone;
        this.isVisible = true;
        let res=await getactivitySignUpRegister({mobile:phone});
        if(res.status!=200){
          return false;
        }
        this.xaxle=this.$decryptByAES(res.x,this.aes_key,this.aes_script);
        this.token=res.token;

        setTimeout(() => {
          this.clean()
          this.$refs.btn.style.left = 0
          this.$refs.bg.style.width = 0
          this.$refs.btn.classList.remove('btnsuccess');
          this.$refs.btn.classList.remove('btnerror');
          this.isDown = false // 鼠标是否按下
          this.btnX = 0 // 鼠标点击的水平位置与滑块移动水平位置的差
          this.imgX = 0
          this.imageCanvas('restore')
          this.imgIndex = this.randImageIndex(this.imgIndex, this.maxImage)


          document.addEventListener('mousemove', this.mouseMove);
          this.imageCanvas();

        }, 200);
      },

    // 图片
    randImageIndex(imgIndex, maxImage) {
      if (imgIndex >= maxImage) {
        imgIndex = 0;
        return imgIndex;
      }
      imgIndex++;
      return imgIndex;
    },
    // 生成随机数字
    randomNumber(min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    // 鼠标按下时
    mouseDown(e) {
      if (this.isEnabled) { // 只有开关开启时才执行
        this.isDown = true
        this.btnX = e.clientX - this.$refs.btn.offsetLeft
      }
    },
    // 鼠标滑动时
    // mouseMove(e) {
    //   if (this.isEnabled) { // 只有开关开启时才执行
    //     // 滑块左端向右边移动的距离
    //     let moveX = e.clientX - this.btnX
    //     if (this.isDown) {
    //       // 滑块滑动时不能超过的距离，根据新尺寸计算
    //       const maxLeft = 400 - 60; // 假设滑块宽度为40

    //       if(this.$refs.btn.offsetLeft >= maxLeft){
    //         this.$refs.btn.offsetLeft=maxLeft-1;
    //         return false;
    //       }
    //       if(this.$refs.btn.offsetLeft <= 0){
    //         this.$refs.btn.offsetLeft=0+1;
    //         return false;
    //       }
          
    //       if (this.$refs.btn.offsetLeft <= maxLeft && this.$refs.btn.offsetLeft >= 0) {

    //         this.$refs.btn.style.left = `${moveX}px`
    //         this.blockCanvas.style.left = `${moveX - this.imgX}px`
    //         this.$refs.bg.style.width = `${moveX}px`
    //       }

         
    //     }
    //   }
    // },

    mouseMove(e) {
    if (this.isEnabled) { // 只有开关开启时才执行
        if (this.isDown) {
            // 滑块滑动时不能超过的距离，根据新尺寸计算
            const maxLeft = 400 - 60; // 假设滑块宽度为60

            // 计算鼠标相对于初始位置的偏移量
            const offsetX = e.clientX - this.btnX;

            // 计算滑块当前的实际位置
            let currentLeft =  offsetX;

            // 限制滑块位置在有效范围内
            if (currentLeft < 0) {
                currentLeft = 0;
            } else if (currentLeft > maxLeft) {
                currentLeft = maxLeft;
            }

            this.$refs.btn.style.left = `${currentLeft}px`;
            this.blockCanvas.style.left = `${currentLeft - this.imgX}px`;
            this.$refs.bg.style.width = `${currentLeft}px`;
        }
    }
},






    
    // 滑动中松开
    async mouseUp() {
      if (this.isEnabled) { // 只有开关开启时才执行
        let leftX = this.$refs.btn.offsetLeft;

      //   把leftX转成字符串
        this.isDown = false;

        let res=await setverifyCaptcha({x:this.$encryptByAES(leftX.toString(),this.aes_key,this.aes_script),token:this.token});
        if(res.status==200){
          // 滑动成功时的逻辑
          this.$refs.btn.classList.add('btnsuccess');
          this.isVisible=false;
          // 写一个方法,传到父组件里面去  
          this.$emit('success');
          
        }else{
          this.$refs.btn.classList.add('btnerror');
          setTimeout(() => {
              this.refresh();
          }, 200);
        }
      //   // 方块的位置和缺失的位置重合允许左右2px的误差
      //   if (this.imgX >= leftX - 1 && this.imgX <= leftX + 1) {
      //     // 滑动成功时的逻辑
      //     this.$refs.btn.classList.add('btnsuccess')
      //     this.isDown = false
      //   }
      //   // 如果滑动失败，滑块自动回到左边
      //   if (this.isDown) {
      //     this.$refs.btn.classList.add('btnerror')
      //   }
        // 开关原则
        this.isDown = false;
        this.isEnabled = false;
      }
    },
    // 画图
   async imageCanvas() {
      this.blockCanvas = this.blockCanvas? this.blockCanvas.remove() : null
      this.blockCanvas = this.createCanvas(400, 280)
      this.$refs.verification.insertBefore(this.blockCanvas, this.$refs.slideVerify)

      // 设置 slideVerify 的 width 和 height
      const slideVerify = this.$refs.slideVerify;
      slideVerify.width = 400;
      slideVerify.height = 280;

      // alert(this.randomNumber(60, 300))
      let x = Number(this.xaxle); // 根据新宽度调整随机范围

      this.yaxle=this.randomNumber(60, 200);

      let y = this.yaxle;
      this.imgX = x
      let c = this.$refs.slideVerify
      let bg = c.getContext('2d')
      let img = this.$refs.imgs
      let bk = this.blockCanvas.getContext('2d')
      // 在两块画布上都放上相同的图片，指定绘制尺寸
      img.onload = () => {
        bg.drawImage(img, 0, 0, 400, 280)
        bk.drawImage(img, 0, 0, 400, 280)
      }
      this.drawBlock(bg, x, y, 'fill')
      this.drawBlock(bk, x, y, 'clip')
    },
    // 画抠出来的方块
    drawBlock(ctx, x, y, type) {
      ctx.beginPath()
      ctx.moveTo(x, y)
      ctx.arc(x + 42 / 2, y - 9 + 2, 9, 0.72 * Math.PI, 2.26 * Math.PI)
      ctx.lineTo(x + 42, y)
      ctx.arc(x + 42 + 9 - 2, y + 42 / 2, 9, 1.21 * Math.PI, 2.78 * Math.PI)
      ctx.lineTo(x + 42, y + 42)
      ctx.lineTo(x, y + 42)
      ctx.arc(x + 9 - 2, y + 42 / 2, 9 + 0.4, 2.76 * Math.PI, 1.24 * Math.PI, true)
      ctx.lineTo(x, y)
      ctx.lineWidth = 2
      ctx.fillStyle = 'rgba(255, 255, 255, 0.7)'
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.7)'
      ctx.stroke()
      ctx[type]()
      ctx.globalCompositeOperation = 'destination-over'
      // 解决进入页面时不自动扣拼图样式的麻烦(有时需要鼠标点击后才会出现裁剪后的拼图)
      this.blockCanvas.style.left = `-${x}px`
    },

    closeModal(){
      this.refresh();
      this.imgIndex=0;
      this.isVisible = false;
    },
    // 刷新
    async refresh() {
      this.isEnabled = true;
      // 重新获取x
      let res=await getactivitySignUpRegister({mobile:this.phone});
        if(res.status!=200){
          return false;
        }
        
        this.xaxle=this.$decryptByAES(res.x,this.aes_key,this.aes_script);
        this.token=res.token;

      if (this.imgIndex == this.randImageIndex(this.imgIndex, this.maxImage)) {
        return false
      }
      this.clean()
      this.$refs.btn.style.left = 0
      this.$refs.bg.style.width = 0
      this.$refs.btn.classList.remove('btnsuccess');
      this.$refs.btn.classList.remove('btnerror');
      this.isDown = false // 鼠标是否按下
      this.btnX = 0 // 鼠标点击的水平位置与滑块移动水平位置的差
      this.imgX = 0
      this.imageCanvas('restore')
      this.imgIndex = this.randImageIndex(this.imgIndex, this.maxImage)
    },
    // 清空canvas
    clean() {
      let cxt2 = this.$refs.slideVerify.getContext('2d')
      cxt2.clearRect(0, 0, 400, 280)
    },
    // 新建canvas
    createCanvas(width, height) {
      const canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height
      canvas.style.position = 'absolute'
      return canvas
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep(){
  .el-dialog__header{
    position: relative;
    z-index: 999999999999999;
  }
  .el-dialog__body{
      padding: 0px 20px 30px;
  }
  .el-dialog{
      border-radius: 8px;
  }
}
.verification {
  position: relative;
  width: 400px;
  margin: 0 auto;
}
.slide-wrapper {
  position: relative;
  width: 400px;
  height: 40px;
}
.bg-start {
  height: 44px;
  background: #B7251E;
  border-radius: 5px;
  padding: 2px;

  .text{
    color: #ffffff;
  }
}
.bg {
  position: absolute;
  height: 40px;
  background: rgba(255, 255, 255, 0.5);
}
.text {
  position: absolute;
  width: 100%;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 0;
  /* z-index: 1; */
}
.text-success {
  color: white;
  z-index: 2;
}
.btn {
  position: absolute;
  width: 40px;
  height: 40px;
  line-height: 36px;
  z-index: 1;
  border-radius: 5px;
  background: #ffffff;
  text-align: center;
  box-shadow: 0 0 1px 1px #fff;
  margin-left: 2px;
  &::after{
    font-family: "iconfont";
    content: "\e683";
    color: #666666;
    font-style: 16px;
  }
  &::before{
    content: "";
    display: block;
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
  }
}
.btnsuccess::after {
    font-family: "iconfont";
    content: "\e64d";
    font-size: 18px;
    color: green;
}
.btnerror::after{
      font-family: "iconfont";
      content: "\e8e7";
      font-size: 18px;
      color: red;
}
.refresh {
    cursor: pointer;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    position: absolute;
    z-index: 1;
    top: 10px;
    right: 10px;
    border:none;
    background: rgba($color: #ffffff, $alpha: 0.8);

    .iconfont{
      color: #777;
    }
}
</style>